import { mapGetters, mapMutations, mapActions } from 'vuex'
import Loading from '@/components/loading/index.vue'
import FileUpload from '@/components/file-upload/index.vue'

export default {
  components: {
    Loading,
    FileUpload
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dialog: false,
      isLoading: false,
      uploadedFile: [],
      headers: [
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false
        },
        {
          text: 'Nome',
          value: 'name',
          align: 'left'
        },
        {
          text: 'Data de expiração',
          value: 'expiringDate',
          align: 'center'
        }
      ]
    }
  },
  mounted () {
    this.dialog = true

    this.getAllClientFiles()
  },
  beforeDestroy () {
    this.CLEAR_CLIENT_FILES_STORE()
    this.SET_SELECTED_CLIENT()
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterSelectedClient',
      'getterAllClientFiles'
    ]),
    isValidDataUploadedFiles () {
      return this.uploadedFile.length > 0 && (this.uploadedFile.find((item) => item.name === '') === undefined)
    }
  },
  methods: {
    ...mapActions([
      'actionGetAllClientFiles',
      'actionRemoveClientFile',
      'actionAddClientFile'
    ]),
    ...mapMutations([
      'CLEAR_CLIENT_FILES_STORE',
      'SET_SELECTED_CLIENT'
    ]),
    downloadFile (item) {
      if (item.link) {
        window.open(item.link, '_blank')
      } else {
        this.sendToast({
          text: 'Ops, o arquivo selecionado não tem link para baixar',
          type: 'warning'
        })
      }
    },
    formatDataToSend (date) {
      if (!date) {
        return null
      }

      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    formatDatePresentation (date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    addClientFile () {
      const updatedParams = this.uploadedFile.map((item) => ({
        ...item,
        expiringDate: item.expiredDate ? this.formatDataToSend(item.expiredDate) : '',
        idClient: this.getterSelectedClient.idClient,
        idUserLogged: this.getterAccount.idUser
      }))

      this.isLoading = true

      this.actionAddClientFile(updatedParams)
        .then(() => {
          this.isLoading = false

          this.uploadedFile = []

          this.sendToast({
            text: 'Arquivos adicionados com sucesso',
            type: 'success'
          })
        })
        .catch(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Ocorreu um erro ao adicionar os arquivos, tente novamente mais tarde',
            type: 'danger'
          })
        })
    },
    getAllClientFiles () {
      this.isLoading = true

      this.actionGetAllClientFiles(this.getterSelectedClient.idClient)
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar os dados, tente novamente mais tarde',
            type: 'danger'
          })
        })
    },
    removeClientFile (item) {
      if (item.idFile) {
        const params = {
          idFile: item.idFile,
          'x-id-user-logged': this.getterAccount.idUser
        }

        this.isLoading = true

        this.actionRemoveClientFile(params)
          .then(() => {
            this.isLoading = false

            this.sendToast({
              text: 'Arquivo removido com sucesso',
              type: 'success'
            })
          })
          .catch(() => {
            this.isLoading = false

            this.sendToast({
              text: 'Ocorreu um erro ao remover o arquivo, tente novamente mais tarde',
              type: 'danger'
            })
          })
      } else {
        this.sendToast({
          text: 'Não é possível remover este arquivo, ele ainda não possui um identificador',
          type: 'warning'
        })
      }
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
